import React from "react";
import "./CopyRight.css"
const CopyRight = () => (
   <>
        <div style={{ height: "2rem", backgroundColor: "#38B6FF" }}
        className="social-menu-div d-flex align-items-center justify-content-center bg-dark">
        <ul>
          <li data-sal="slide-up"><a href="https://www.facebook.com/bizdamncompany"><i className="fab fa-facebook-f"></i></a></li>
          <li data-sal="slide-up"><a href="https://in.pinterest.com/bizdamn"><i className="fab fa-pinterest-p"></i></a></li>
          <li data-sal="slide-up"><a href="https://twitter.com/biz_damn"><i className="fab fa-twitter"></i></a></li>
          <li data-sal="slide-up"><a href="https://www.instagram.com/bizdamn/"><i className="fab fa-instagram"></i></a></li>
          <li data-sal="slide-up"><a href="https://www.linkedin.com/company/bizdamn"><i className="fab fa-linkedin"></i></a></li>
        </ul>
      </div>

      <div className="copyright container-fluid text-center bg-dark text-white py-2">
        &copy; 2021 bizdamn.tech
      </div>
   </>
  )
  export default CopyRight;